/* eslint-disable max-len */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, NavLink, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import { ModalContext } from 'App';
import queryString from 'query-string';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from 'session';
import useDebounce from 'modules/common/components/UseDebounce';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import Select from 'react-select';
import { reactSelectCustomStyle } from 'modules/common/components/Select';
import * as actions from '../action';
import * as c from '../constant';
import SubscriberContent from './SubscriberContent';
import ProfileEditModal from '../components/ProfileEditModal';
import AddSubscriberModal from '../components/AddSubscriberModal';
import ChangePasswordModal from '../components/ChangePasswordModal';
import MobuleTransactionListing from './MobuleTransactionListing';
import ChangePinModal from '../components/ChangePinModal';
import UpdatePinModalContainer from '../components/UpdatePinModalContainer';

import CmsContext from '../../../context/CmsContext';

const form = {
  keyword: '',
  transaction_status: '',
  start_date: '',
  end_date: '',
  is_resident: '',
};

const FilterByIsResident = ({ value, ...rest }) => {
  const options = [
    {
      label: 'All',
      value: '',
    },
    {
      label: 'Resident',
      value: 1,
    },
    {
      label: 'Non-Resident',
      value: 0,
    },
  ];

  return (
    <div className="d-flex align-items-right mb-3">
      <div className="d-flex align-items-center ml-auto">
        <div>
          <label className="form-label mt-2 mb-0">
            <span className="text-muted">
              <h6>Filter By Residency:</h6>
            </span>
          </label>
        </div>
        <Select
          value={
            options.find(item => `${value}` === `${_.get(item, 'value')}`) || ''
          }
          styles={reactSelectCustomStyle}
          options={options}
          {...rest}
        />
      </div>
    </div>
  );
};

FilterByIsResident.propTypes = {
  value: PropTypes.string.isRequired,
};

function SubscriberContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
  approveTransaction,
  showTransaction,
  taxpayer,
  activateProfile,
  activating,
  permissions,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const selectedTransaction = match.params.id;

  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const UpdateData = () => {
    if (Acl(permissions, ['VIEW MRID SUBSCRIBERS'])) {
      getTransactionList({ has_mrid_account: 1 });
    }
    if (!Acl(permissions, ['VIEW MRID SUBSCRIBERS'])) {
      getTransactionList({});
    }

    if (!_.isEmpty(selectedTransaction)) {
      showTransaction(selectedTransaction);
    }
  };

  // useEffect(() => {
  //   UpdateData();
  //   return () => {
  //     setModal({ isOpen: false });
  //   };
  // }, []);

  const handleActivate = e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to activate this user?',
      () => {
        activateProfile(selectedTransaction, {}, () => {
          UpdateData();
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm) {
      if (Acl(permissions, ['VIEW MRID SUBSCRIBERS'])) {
        getTransactionList({ q: formData.keyword, has_mrid_account: 1 }); // filter subscriber with mrid account
      }
      if (!Acl(permissions, ['VIEW MRID SUBSCRIBERS'])) {
        getTransactionList({ q: formData.keyword, });
      }
    }

    if (!debouncedSearchTerm) setFormData([]);

    return () => {
      setModal({ isOpen: false });
    };
  }, [debouncedSearchTerm]);

  const param = {
    module_type: 'PSA',
    transaction_type: 'BIRTH CERTIFICATE',
    q: formData.keyword,
    sort_by: 'asc',
    ...(Acl(permissions, ['VIEW MRID SUBSCRIBERS']) && { has_mrid_account: 1 }),
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeSelect = key => e => {
    setFilter({
      ...filter,
      [key]: e.value,
    });
    getTransactionList(
      {
        ...filter,
        [key]: e.value,
      },
      ({ data }) => {
        history.push(`/subscribers/${_.get(data, '0.id')}`);
      }
    );
  };

  const handleVerifyOtp = () => {
    // e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdatePinModalContainer taxPayerId={selectedTransaction} mobileNo={_.get(taxpayer, 'attributes.new_mobile_number')} />
      ),
      title: 'Enter OTP for this mobile number',
      modalSize: 'modal-md',
    });
  };

  const handleEditProfile = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ProfileEditModal
          taxpayers={taxpayer}
          taxpayerId={selectedTransaction}
          handleVerifyOtp={handleVerifyOtp}
        />
      ),
      title: 'Update Subscriber Account',
      modalSize: 'modal-xl',
    });
  };

  const handleChangePassword = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ChangePasswordModal
          taxpayers={taxpayer}
          taxpayerId={selectedTransaction}
        />
      ),
      title: 'Change Password',
      modalSize: 'modal-md',
    });
  };

  const handleChangePin = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ChangePinModal taxpayers={taxpayer} taxpayerId={selectedTransaction} />
      ),
      title: 'Change Pin',
      modalSize: 'modal-md',
    });
  };

  const handleApprove = data => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Approve this application?',
      remarks => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'WAITING FOR PAYMENT',
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleAddAccount = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AddSubscriberModal
          taxpayers={taxpayer}
          taxpayerId={selectedTransaction}
        />
      ),
      title: 'Add Subscriber Account',
      modalSize: 'modal-md',
    });
  };

  const handleReject = data => e => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to Reject this application',
      remarks => {
        approveTransaction(
          _.get(data, 'id'),
          {
            remarks,
            status: 'FOR APPEARANCE',
          },
          () => {
            showTransaction(_.get(data, 'id'));
          }
        );
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // download CSV
  const downloadCSV = () => {
    const path = `${process.env.REACT_APP_WS}api/v1/administrators/subscribers/export_csv`;
    const params = queryString.stringify({
      ...queryString.parse(window.location.search),
      ...formData,
      // permit_type: ???', // add permit type later
      bearer_token: token,
      email: _.get(authProfile, 'email'),
      module_type: 'CITIZEN',
    });
    return `${path}?${params}`;
  };

  const photo = _.get(taxpayer, 'attributes.photo') || false;

  return (
    <>
      {Acl(permissions, ['ADD SUBSCRIBER']) && (
        <div className="row d-flex justify-content-end mr-3">
          <button
            onClick={handleAddAccount}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  mt-2"
            type="button"
          >
            Add Subscriber Account
          </button>
        </div>
      )}
      <div className="card-content-listing">
        <Route
          path={`${match.path}`}
          render={({ match: { params } }) => {
            return (
              <GenericListPair
                customFilter={
                  <FilterByIsResident
                    value={_.get(filter, 'is_resident')}
                    onChange={handleOnChangeSelect('is_resident')}
                  />
                }
                downloadCSV={downloadCSV}
                moduleName={`${_.get(CMS_COMPONENTS, 'SMART_CITY_SIDE_MENU_LABELS_V2') ? 'Registrants/ Subscribers' : 'Subscribers List'}`}
                // getData={Acl(permissions, ['VIEW MRID SUBSCRIBERS']) ? () => getTransactionList({ has_mrid_account: 1 }) : getTransactionList}
                getData={getTransactionList}
                setParams={param}
                setKeyword={handleOnChange}
                setStatusFilter={handleOnChangeSelect(
                  _.get(formData, 'transaction_status')
                )}
                status={_.get(filter, 'transaction_status') || ''}
                keyword={_.get(formData, 'keyword') || ''}
                keywordPlaceholder="Search Subscriber..."
                pathName={`${match.path}`}
                listName="Subscriber"
                label="Basic Information"
                renderItem={item => (
                  <div className="px-3 py-3">
                    <div className="transaction-list-company">
                      {(
                        _.get(item, 'attributes.first_name') || '---'
                      ).toUpperCase()}
                      &nbsp;
                      {(
                        _.get(item, 'attributes.middle_name') || ''
                      ).toUpperCase()}
                      &nbsp;
                      {(
                        _.get(item, 'attributes.last_name') || ''
                      ).toUpperCase()}
                      &nbsp;
                      {(
                        _.get(item, 'attributes.extension_name') || ''
                      ).toUpperCase()}
                    </div>
                    {_.get(item, 'attributes.is_user_id_auth') === 0 && (
                      <h4 className="mt-1 mb-0 transaction-list-name">
                        {_.get(item, 'attributes.mobile_number') || '---'}
                      </h4>
                    )}
                    {_.get(item, 'attributes.is_user_id_auth') === 1 && (
                      <h4 className="mt-1 mb-0 transaction-list-name">
                        {_.get(item, 'attributes.user_id') || '---'}
                      </h4>
                    )}
                  </div>
                )}
                isLoading={isLoading}
                statusFilter={false}
                selected={params.id}
                data={transactionList}
                dataPager={transactionListPager}
                handleSelectRow={data => {
                  history.push(`/subscribers/${_.get(data, 'id')}`);
                }}
                renderContent={() => (
                  <React.Fragment>
                    <div className="px-4">
                      <div className="row name-banner">
                        <div className="p-0 d-flex flex-nowrap w-100">
                          <div className="d-flex ml-auto">
                            {!_.get(taxpayer, 'attributes.is_active') && (
                              <button
                                disabled={activating}
                                onClick={handleActivate}
                                type="button"
                                className="btn btn-success mr-2"
                              >
                                {activating ? (
                                  <>
                                    <i className="fa fa-spin fa-spinner" />{' '}
                                    &nbsp; Loading
                                  </>
                                ) : (
                                    'Activate'
                                  )}
                              </button>
                            )}
                            {Acl(permissions, ['CITIZEN EDIT']) && (
                              <button
                                // disabled={activating}
                                onClick={handleEditProfile}
                                type="button"
                                className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2"
                              >
                                {activating ? (
                                  <>
                                    <i className="fa fa-spin fa-spinner" />{' '}
                                    &nbsp; Loading
                                  </>
                                ) : (
                                    'Edit Profile'
                                  )}
                              </button>
                            )}

                            {Acl(permissions, ['CITIZEN CHANGE PASSWORD']) &&
                              // _.get(taxpayer, 'attributes.is_user_id_auth') === 0 &&
                              (
                                <button
                                  // disabled={activating}
                                  onClick={handleChangePassword}
                                  type="button"
                                  className="btn btn-secondary cms-bg-color-secondary cms-outline-secondary"
                                >
                                  {activating ? (
                                    <>
                                      <i className="fa fa-spin fa-spinner" />{' '}
                                      &nbsp;
                                    </>
                                  ) : (
                                      'Change Password'
                                    )}
                                </button>
                              )}
                            {Acl(permissions, ['CITIZEN CHANGE PIN']) &&
                              _.get(taxpayer, 'attributes.is_user_id_auth') ===
                              1 && (
                                <button
                                  // disabled={activating}
                                  onClick={handleChangePin}
                                  type="button"
                                  className="btn btn-secondary"
                                >
                                  {activating ? (
                                    <>
                                      <i className="fa fa-spin fa-spinner" />{' '}
                                      &nbsp;
                                    </>
                                  ) : (
                                      'Change Pin'
                                    )}
                                </button>
                              )}
                          </div>
                        </div>
                        <div className="name-image-inner">
                          <div className="image-name-wrap">
                            {photo && photo !== '-/format/jpeg/' ? (
                              <img
                                className="round-img"
                                alt="Client Profile"
                                src={_.get(taxpayer, 'attributes.photo')}
                              />
                            )
                              : (
                                <img
                                  className="round-img"
                                  alt="Client Profile"
                                  src={ImagePlaceholder}
                                />
                              )}
                          </div>
                          <div className="name-banner-name">
                            {`${(
                              _.get(taxpayer, 'attributes.first_name') || '---'
                            ).toUpperCase()} ${(
                              _.get(taxpayer, 'attributes.middle_name') || ''
                            ).toUpperCase()} ${(
                              _.get(taxpayer, 'attributes.last_name') || ''
                            ).toUpperCase()} ${(
                              _.get(taxpayer, 'attributes.extension_name') || ''
                            ).toUpperCase()}`}
                          </div>
                        </div>
                      </div>
                      <SideScrollingTab dragToScroll>
                        <ul className="nav nav-tabs subscriber-tab">
                          {Acl(permissions, ['VIEW SUBSCRIBERS PROFILE']) && (
                          <li className="nav-item">
                            <NavLink
                              exact
                              className="nav-link"
                              activeClassName="active"
                              to={`/subscribers/${params.id}?`}
                            >
                              Profile
                            </NavLink>
                          </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS BIRTH CERT']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/birth-certificates`}
                              >
                                Birth Certificates
                              </NavLink>
                            </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS CEDULA']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/cedulas`}
                              >
                                Cedulas
                              </NavLink>
                            </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS OHP']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/occupational-and-healths`}
                              >
                                Occupational & Healths
                              </NavLink>
                            </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS RPTAX']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/rptax`}
                              >
                                RPTAX
                              </NavLink>
                            </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS BTAX']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/btax`}
                              >
                                BTAX
                              </NavLink>
                            </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS NOV']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/nov`}
                              >
                                NOV
                              </NavLink>
                            </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS OVRS']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/ovrs`}
                              >
                                OVRS
                              </NavLink>
                            </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS BPLS']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/bpls`}
                              >
                                BPLS
                              </NavLink>
                            </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS EBOSS']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/t_bpls`}
                              >
                                E-Boss
                              </NavLink>
                            </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS DEATH CERT']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/death-certificates`}
                              >
                                Death Certificates
                              </NavLink>
                            </li>
                          )}
                          {Acl(permissions, ['VIEW SUBSCRIBERS MISC FEES']) && (
                            <li className="nav-item">
                              <NavLink
                                className="nav-link"
                                activeClassName="active"
                                to={`/subscribers/${params.id}/miscellaneous-fees`}
                              >
                                Miscellaneous Fees
                              </NavLink>
                            </li>
                          )}
                        </ul>
                      </SideScrollingTab>
                      <Switch>
                        <Route
                          exact
                          path="/subscribers"
                          render={() =>
                            !params.id && transactionList.length > 0 ? (
                              <Redirect
                                to={`/subscribers/${_.get(
                                  transactionList,
                                  '0.id'
                                )}`}
                              />
                            ) : null
                          }
                        />
                        <Route
                          exact
                          path="/subscribers/:id"
                          render={() => (
                            <SubscriberContent
                              UpdateData={UpdateData}
                              onApprove={handleApprove}
                              onReject={handleReject}
                            />
                          )}
                        />
                        <Route
                          path="/subscribers/:id/:transaction_type"
                          component={MobuleTransactionListing}
                        />
                      </Switch>
                    </div>
                  </React.Fragment>
                )}
              />
            );
          }}
        />
      </div>
    </>
  );
}

SubscriberContainer.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  activating: PropTypes.bool.isRequired,
  activateProfile: PropTypes.instanceOf(Function).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  activating: api.loading.indexOf(c.ACTIVATE_PROFILE) > -1,
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item`) || {}),
    } || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SubscriberContainer);
